import React from 'react'
import ChevronDownIcon from 'assets/images/chevron-down-24.svg?react'
import styles from './style.module.scss'

interface TodoSection {
  title: string
  count: number
}

interface TodoSectionHeaderProps {
  section: TodoSection
  isExpanded: boolean
  onToggle: () => void
}

const TodoSectionHeader: React.FC<TodoSectionHeaderProps> = ({ section, isExpanded, onToggle }) => {
  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation()
    onToggle()
  }

  return (
    <div className={styles.sectionBody} onClick={handleClick}>
      <ChevronDownIcon
        className={styles.sectionChevron}
        style={{
          transform: isExpanded ? 'rotate(0deg)' : 'rotate(-90deg)',
          transition: 'transform 0.2s',
        }}
      />
      <span className={styles.sectionTitle}>{section.title}</span>
      <span className={styles.sectionCount}>{section.count}</span>
    </div>
  )
}

export default TodoSectionHeader
